import {
    AnimationBaseController,
    GameApiBase
} from "@denishussar/html5-game-engine";
import {Inject} from "@denishussar/html5-game-engine";
import {IAnimationControllerConfiguration} from "@denishussar/html5-game-engine";
import {GameModel} from "../../Models/GameModel";
import {AnimationContents} from "../AnimationContents";
import {GameLogic} from "../../Logic/GameLogic";

import {ButtonController, IButtonControllerOptions} from "../Common/ButtonController";
import {LocalizationContents} from "../../LocalizationContents";

export interface IIntroScreenControllerOptions
{
}

export class MainMenuController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options:IIntroScreenControllerOptions,
                       @Inject private _gameLogic: GameLogic,
                       @Inject private _arenaApi: GameApiBase) {
        super("MainMenu");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.MAIN_MENU_SCREEN_JSON,
            libraryName: "main_menu",
            childControllers: {
                PlayButton: {
                    instanceName: "btn_play",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{
                            this._gameLogic.charSelect();
                            this._gameLogic.hideMainMenu();
                            // this._gameLogic.hideMainMenuContainer();
                        },
                        localKey: LocalizationContents.keys.menu_play
                    }
                },
                SettingButton: {
                    instanceName: "btn_settings",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{
                            this._gameLogic.settings();
                            this._gameLogic.hideMainMenu();
                        },
                        localKey: LocalizationContents.keys.menu_settings
                    }
                },
                RecordsButton: {
                    instanceName: "btn_record",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{
                            this._gameLogic.records();
                            this._gameLogic.hideMainMenu();
                        },
                        localKey: LocalizationContents.keys.menu_records
                    }
                },
                CloseButton: {
                    instanceName: "btn_close",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{
                            this._gameLogic.showSpecialWindow();
                            window.location.href = "index.html";
                        },
                        localKey: LocalizationContents.keys.menu_exit
                    }
                },
            },
            modelWatch: {
                
            }
        };
    }

    protected onInitialize(): void {
        this.display.scale.set(.65);
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }

}

